import React, { useContext } from 'react';

import GridViewIcon from '../../../../assets/icons/GridViewIcon';
import ListViewIcon from '../../../../assets/icons/ListViewIcon';
import { DiscoverContext } from '../../../../context/DiscoverContext';
import { colorsPalette } from '../../../../theme';
import { LIST_VIEW, GRID_VIEW } from '../../const';
import useStyles from './styles';

const ViewSwitcher = ({ setPage }) => {
  const classes = useStyles();
  const { discoverView, setDiscoverView, setSearchState } = useContext(DiscoverContext);

  const toggleView = (view) => {
    setPage(0);
    //set page to first to prevent breaking page logic
    setSearchState((prevState) => ({
      ...prevState,
      page: 1,
    }));
    setDiscoverView(view);
  };

  return (
    <div className={classes.wrapper}>
      <ListViewIcon
        className={classes.listIcon}
        color={discoverView === LIST_VIEW ? colorsPalette.blue : colorsPalette.gray}
        onClick={() => toggleView(LIST_VIEW)}
      />
      <GridViewIcon
        className={classes.gridIcon}
        color={discoverView === GRID_VIEW ? colorsPalette.blue : colorsPalette.gray}
        onClick={() => toggleView(GRID_VIEW)}
      />
    </div>
  );
};

export default ViewSwitcher;
